module.exports = __webpack_public_path__ + "static/media/img_simulation_assessment_info_1_3face.f923c881.jpg";